import {
  FETCH_PATIENTS_SUCCESS,
  FETCH_PATIENTS_REQUEST,
  FETCH_PATIENTS_FAILURE,
  UPDATE_PATIENT_REQUEST,
  UPDATE_PATIENT_SUCCESS,
  UPDATE_PATIENT_FAILURE,
  SHOW_PATIENT_EDIT_FORM,
  DELETE_PATIENT_REQUEST,
  DELETE_PATIENT_SUCCESS,
  DELETE_PATIENT_FAILURE,
  SET_PATIENT_VALIDATION_ERRORS,
  SHOW_PATIENT_NEW_FORM,
  CREATE_PATIENT_REQUEST,
  CREATE_PATIENT_SUCCESS,
  CREATE_PATIENT_FAILURE,
} from "constants/Patient";

import {
  addPatient,
  formtValidationErrors,
  removePatient,
  updatePatient,
} from "utils/Patient";

const initState = {
  loading: false,
  updating: false,
  creating: false,
  list: [],
  errorMessage: "",
  validationErrors: [],
  showEditForm: false,
  showNewForm: false,
  deleting: false,
};

const patient = (state = initState, action) => {
  switch (action.type) {
    case FETCH_PATIENTS_REQUEST:
      return {
        ...state,
        loading: true,
        showEditForm: false,
        showNewForm: false,
      };
    case FETCH_PATIENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.payload,
      };
    case FETCH_PATIENTS_FAILURE:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload,
      };

    case SET_PATIENT_VALIDATION_ERRORS:
      return {
        ...state,
        validationErrors: formtValidationErrors(action.payload),
      };
    case SHOW_PATIENT_EDIT_FORM:
      return {
        ...state,
        showEditForm: !state.showEditForm,
      };
    case SHOW_PATIENT_NEW_FORM:
      return {
        ...state,
        showNewForm: !state.showNewForm,
      };
    case UPDATE_PATIENT_REQUEST:
      return {
        ...state,
        updating: true,
        errorMessage: "",
        validationErrors: [],
      };
    case UPDATE_PATIENT_SUCCESS:
      return {
        ...state,
        updating: false,
        list: updatePatient(state, action),
        errorMessage: "",
        validationErrors: [],
        showEditForm: false,
      };
    case UPDATE_PATIENT_FAILURE:
      return {
        ...state,
        updating: false,
        errorMessage: action.payload,
        validationErrors: [],
      };
    case DELETE_PATIENT_REQUEST:
      return {
        ...state,
        deleting: true,
      };
    case DELETE_PATIENT_SUCCESS:
      return {
        ...state,
        deleting: false,
        list: removePatient(state, action),
      };
    case DELETE_PATIENT_FAILURE:
      return {
        ...state,
        deleting: false,
        errorMessage: action.payload,
      };

    case CREATE_PATIENT_REQUEST:
      return {
        ...state,
        creating: true,
      };
    case CREATE_PATIENT_SUCCESS:
      return {
        ...state,
        creating: false,
        showNewForm: !state.showNewForm,
        list: addPatient(state, action),
      };
    case CREATE_PATIENT_FAILURE:
      return {
        ...state,
        creating: false,
        errorMessage: action.payload,
      };
    default:
      return state;
  }
};

export default patient;
